'use client';

import { I18nProvider } from '@freedraw/i18n/react';
import type { AppLocale } from '@freedraw/i18n/shared';
import dynamic from 'next/dynamic';

import type { LoginCardProps } from '@/components/login/login-card';
import { MuiAppProvider } from '@/components/mui-app-provider';

// Mirrors DrawingBoardEntry: providers stay outside the client-only boundary so
// I18nProvider can initialise i18next before the translated card renders.
const LoginCard = dynamic(async () => (await import('@/components/login/login-card')).LoginCard, {
  ssr: false,
  loading: () => <div className="board-loading-shell" aria-hidden="true" />
});

type LoginEntryProps = LoginCardProps & {
  initialLocale: AppLocale;
};

export function LoginEntry({ initialLocale, ...props }: LoginEntryProps) {
  return (
    <I18nProvider initialLocale={initialLocale}>
      <MuiAppProvider initialPreference="light">
        <LoginCard {...props} />
      </MuiAppProvider>
    </I18nProvider>
  );
}
